import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './About.css';

function About() {
  return (
    <section id="about" className="py-5 rjc-about-section">
      <Container>
        <h2 className="text-center mb-5 rjc-section-title">About Russell Blanchard Creations</h2>
        <Row className="justify-content-center">
          <Col md={8}>
            <p className="rjc-about-text">
              Welcome to Russell Blanchard Creations, where passion for woodworking meets unparalleled craftsmanship. 
              Founded by Russell James, our workshop is dedicated to creating unique, handcrafted wooden pieces 
              that bring warmth, character, and timeless beauty into your home or office.
            </p>
            <p className="rjc-about-text">
              Every item is meticulously designed and built using traditional techniques combined with modern aesthetics. 
              We believe in the beauty of natural wood and strive to highlight its inherent textures and grains in every creation. 
              From bespoke furniture to intricate decorative pieces, we pour our heart and soul into every project.
            </p>
            <p className="rjc-about-text">
              At R.B.C., we're not just building with wood; we're crafting legacies. We work closely with our clients 
              to understand their vision, ensuring each custom piece is a true reflection of their style and needs. 
              Explore our gallery to see some of our past work, and contact us to bring your unique woodworking dream to life.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;